var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeExpressQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 142,
    r: 6,
    transform: "rotate(0,34,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 178,
    r: 6,
    transform: "rotate(0,34,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 202,
    r: 6,
    transform: "rotate(0,34,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 214,
    r: 6,
    transform: "rotate(0,34,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 226,
    r: 6,
    transform: "rotate(0,34,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 250,
    r: 6,
    transform: "rotate(0,34,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 262,
    r: 6,
    transform: "rotate(0,34,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 334,
    r: 6,
    transform: "rotate(0,34,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 346,
    r: 6,
    transform: "rotate(0,34,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 370,
    r: 6,
    transform: "rotate(0,34,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 130,
    r: 6,
    transform: "rotate(0,46,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 154,
    r: 6,
    transform: "rotate(0,46,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 250,
    r: 6,
    transform: "rotate(0,46,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 274,
    r: 6,
    transform: "rotate(0,46,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 334,
    r: 6,
    transform: "rotate(0,46,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 370,
    r: 6,
    transform: "rotate(0,46,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 142,
    r: 6,
    transform: "rotate(0,58,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 178,
    r: 6,
    transform: "rotate(0,58,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 190,
    r: 6,
    transform: "rotate(0,58,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 226,
    r: 6,
    transform: "rotate(0,58,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 262,
    r: 6,
    transform: "rotate(0,58,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 274,
    r: 6,
    transform: "rotate(0,58,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 286,
    r: 6,
    transform: "rotate(0,58,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 334,
    r: 6,
    transform: "rotate(0,58,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 370,
    r: 6,
    transform: "rotate(0,58,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 130,
    r: 6,
    transform: "rotate(0,70,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 142,
    r: 6,
    transform: "rotate(0,70,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 154,
    r: 6,
    transform: "rotate(0,70,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 190,
    r: 6,
    transform: "rotate(0,70,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 238,
    r: 6,
    transform: "rotate(0,70,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 250,
    r: 6,
    transform: "rotate(0,70,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 262,
    r: 6,
    transform: "rotate(0,70,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 274,
    r: 6,
    transform: "rotate(0,70,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 286,
    r: 6,
    transform: "rotate(0,70,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 334,
    r: 6,
    transform: "rotate(0,70,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 370,
    r: 6,
    transform: "rotate(0,70,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 130,
    r: 6,
    transform: "rotate(0,82,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 154,
    r: 6,
    transform: "rotate(0,82,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 214,
    r: 6,
    transform: "rotate(0,82,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 238,
    r: 6,
    transform: "rotate(0,82,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 250,
    r: 6,
    transform: "rotate(0,82,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 274,
    r: 6,
    transform: "rotate(0,82,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 346,
    r: 6,
    transform: "rotate(0,82,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 142,
    r: 6,
    transform: "rotate(0,94,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 154,
    r: 6,
    transform: "rotate(0,94,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 166,
    r: 6,
    transform: "rotate(0,94,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 178,
    r: 6,
    transform: "rotate(0,94,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 202,
    r: 6,
    transform: "rotate(0,94,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 214,
    r: 6,
    transform: "rotate(0,94,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 262,
    r: 6,
    transform: "rotate(0,94,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 286,
    r: 6,
    transform: "rotate(0,94,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 310,
    r: 6,
    transform: "rotate(0,94,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 322,
    r: 6,
    transform: "rotate(0,94,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 334,
    r: 6,
    transform: "rotate(0,94,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 130,
    r: 6,
    transform: "rotate(0,106,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 154,
    r: 6,
    transform: "rotate(0,106,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 178,
    r: 6,
    transform: "rotate(0,106,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 202,
    r: 6,
    transform: "rotate(0,106,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 226,
    r: 6,
    transform: "rotate(0,106,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 250,
    r: 6,
    transform: "rotate(0,106,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 274,
    r: 6,
    transform: "rotate(0,106,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 298,
    r: 6,
    transform: "rotate(0,106,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 322,
    r: 6,
    transform: "rotate(0,106,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 346,
    r: 6,
    transform: "rotate(0,106,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 370,
    r: 6,
    transform: "rotate(0,106,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 130,
    r: 6,
    transform: "rotate(0,118,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 262,
    r: 6,
    transform: "rotate(0,118,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 274,
    r: 6,
    transform: "rotate(0,118,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 298,
    r: 6,
    transform: "rotate(0,118,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 310,
    r: 6,
    transform: "rotate(0,118,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 334,
    r: 6,
    transform: "rotate(0,118,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 346,
    r: 6,
    transform: "rotate(0,118,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 358,
    r: 6,
    transform: "rotate(0,118,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 370,
    r: 6,
    transform: "rotate(0,118,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 46,
    r: 6,
    transform: "rotate(0,130,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 6,
    transform: "rotate(0,130,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 82,
    r: 6,
    transform: "rotate(0,130,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 94,
    r: 6,
    transform: "rotate(0,130,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 106,
    r: 6,
    transform: "rotate(0,130,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 6,
    transform: "rotate(0,130,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 142,
    r: 6,
    transform: "rotate(0,130,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 154,
    r: 6,
    transform: "rotate(0,130,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 202,
    r: 6,
    transform: "rotate(0,130,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 214,
    r: 6,
    transform: "rotate(0,130,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 238,
    r: 6,
    transform: "rotate(0,130,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 250,
    r: 6,
    transform: "rotate(0,130,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 310,
    r: 6,
    transform: "rotate(0,130,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 322,
    r: 6,
    transform: "rotate(0,130,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 346,
    r: 6,
    transform: "rotate(0,130,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 382,
    r: 6,
    transform: "rotate(0,130,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 394,
    r: 6,
    transform: "rotate(0,130,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 418,
    r: 6,
    transform: "rotate(0,130,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 430,
    r: 6,
    transform: "rotate(0,130,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 454,
    r: 6,
    transform: "rotate(0,130,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 34,
    r: 6,
    transform: "rotate(0,142,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 46,
    r: 6,
    transform: "rotate(0,142,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 82,
    r: 6,
    transform: "rotate(0,142,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 118,
    r: 6,
    transform: "rotate(0,142,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 130,
    r: 6,
    transform: "rotate(0,142,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 142,
    r: 6,
    transform: "rotate(0,142,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 154,
    r: 6,
    transform: "rotate(0,142,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 178,
    r: 6,
    transform: "rotate(0,142,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 190,
    r: 6,
    transform: "rotate(0,142,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 202,
    r: 6,
    transform: "rotate(0,142,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 226,
    r: 6,
    transform: "rotate(0,142,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 238,
    r: 6,
    transform: "rotate(0,142,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 262,
    r: 6,
    transform: "rotate(0,142,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 274,
    r: 6,
    transform: "rotate(0,142,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 310,
    r: 6,
    transform: "rotate(0,142,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 322,
    r: 6,
    transform: "rotate(0,142,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 334,
    r: 6,
    transform: "rotate(0,142,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 346,
    r: 6,
    transform: "rotate(0,142,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 358,
    r: 6,
    transform: "rotate(0,142,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 406,
    r: 6,
    transform: "rotate(0,142,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 418,
    r: 6,
    transform: "rotate(0,142,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 442,
    r: 6,
    transform: "rotate(0,142,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 46,
    r: 6,
    transform: "rotate(0,154,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 58,
    r: 6,
    transform: "rotate(0,154,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 70,
    r: 6,
    transform: "rotate(0,154,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 82,
    r: 6,
    transform: "rotate(0,154,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 106,
    r: 6,
    transform: "rotate(0,154,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 118,
    r: 6,
    transform: "rotate(0,154,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 190,
    r: 6,
    transform: "rotate(0,154,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 202,
    r: 6,
    transform: "rotate(0,154,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 214,
    r: 6,
    transform: "rotate(0,154,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 238,
    r: 6,
    transform: "rotate(0,154,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 250,
    r: 6,
    transform: "rotate(0,154,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 262,
    r: 6,
    transform: "rotate(0,154,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 274,
    r: 6,
    transform: "rotate(0,154,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 310,
    r: 6,
    transform: "rotate(0,154,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 334,
    r: 6,
    transform: "rotate(0,154,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 358,
    r: 6,
    transform: "rotate(0,154,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 382,
    r: 6,
    transform: "rotate(0,154,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 394,
    r: 6,
    transform: "rotate(0,154,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 442,
    r: 6,
    transform: "rotate(0,154,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 466,
    r: 6,
    transform: "rotate(0,154,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 46,
    r: 6,
    transform: "rotate(0,166,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 58,
    r: 6,
    transform: "rotate(0,166,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 70,
    r: 6,
    transform: "rotate(0,166,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 94,
    r: 6,
    transform: "rotate(0,166,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 118,
    r: 6,
    transform: "rotate(0,166,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 154,
    r: 6,
    transform: "rotate(0,166,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 166,
    r: 6,
    transform: "rotate(0,166,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 190,
    r: 6,
    transform: "rotate(0,166,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 202,
    r: 6,
    transform: "rotate(0,166,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 214,
    r: 6,
    transform: "rotate(0,166,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 226,
    r: 6,
    transform: "rotate(0,166,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 274,
    r: 6,
    transform: "rotate(0,166,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 310,
    r: 6,
    transform: "rotate(0,166,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 346,
    r: 6,
    transform: "rotate(0,166,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 370,
    r: 6,
    transform: "rotate(0,166,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 382,
    r: 6,
    transform: "rotate(0,166,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 394,
    r: 6,
    transform: "rotate(0,166,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 406,
    r: 6,
    transform: "rotate(0,166,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 418,
    r: 6,
    transform: "rotate(0,166,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 430,
    r: 6,
    transform: "rotate(0,166,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 442,
    r: 6,
    transform: "rotate(0,166,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 34,
    r: 6,
    transform: "rotate(0,178,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 46,
    r: 6,
    transform: "rotate(0,178,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 70,
    r: 6,
    transform: "rotate(0,178,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 82,
    r: 6,
    transform: "rotate(0,178,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 106,
    r: 6,
    transform: "rotate(0,178,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 142,
    r: 6,
    transform: "rotate(0,178,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 166,
    r: 6,
    transform: "rotate(0,178,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 190,
    r: 6,
    transform: "rotate(0,178,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 202,
    r: 6,
    transform: "rotate(0,178,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 214,
    r: 6,
    transform: "rotate(0,178,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 226,
    r: 6,
    transform: "rotate(0,178,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 238,
    r: 6,
    transform: "rotate(0,178,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 274,
    r: 6,
    transform: "rotate(0,178,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 322,
    r: 6,
    transform: "rotate(0,178,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 358,
    r: 6,
    transform: "rotate(0,178,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 370,
    r: 6,
    transform: "rotate(0,178,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 394,
    r: 6,
    transform: "rotate(0,178,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 34,
    r: 6,
    transform: "rotate(0,190,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 46,
    r: 6,
    transform: "rotate(0,190,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 58,
    r: 6,
    transform: "rotate(0,190,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 94,
    r: 6,
    transform: "rotate(0,190,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 118,
    r: 6,
    transform: "rotate(0,190,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 142,
    r: 6,
    transform: "rotate(0,190,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 6,
    transform: "rotate(0,190,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 202,
    r: 6,
    transform: "rotate(0,190,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 238,
    r: 6,
    transform: "rotate(0,190,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 250,
    r: 6,
    transform: "rotate(0,190,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 262,
    r: 6,
    transform: "rotate(0,190,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 274,
    r: 6,
    transform: "rotate(0,190,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 298,
    r: 6,
    transform: "rotate(0,190,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 310,
    r: 6,
    transform: "rotate(0,190,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 346,
    r: 6,
    transform: "rotate(0,190,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 358,
    r: 6,
    transform: "rotate(0,190,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 370,
    r: 6,
    transform: "rotate(0,190,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 382,
    r: 6,
    transform: "rotate(0,190,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 418,
    r: 6,
    transform: "rotate(0,190,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 442,
    r: 6,
    transform: "rotate(0,190,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 34,
    r: 6,
    transform: "rotate(0,202,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 58,
    r: 6,
    transform: "rotate(0,202,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 70,
    r: 6,
    transform: "rotate(0,202,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 106,
    r: 6,
    transform: "rotate(0,202,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 118,
    r: 6,
    transform: "rotate(0,202,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 142,
    r: 6,
    transform: "rotate(0,202,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 154,
    r: 6,
    transform: "rotate(0,202,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 166,
    r: 6,
    transform: "rotate(0,202,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 238,
    r: 6,
    transform: "rotate(0,202,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 262,
    r: 6,
    transform: "rotate(0,202,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 274,
    r: 6,
    transform: "rotate(0,202,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 298,
    r: 6,
    transform: "rotate(0,202,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 346,
    r: 6,
    transform: "rotate(0,202,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 358,
    r: 6,
    transform: "rotate(0,202,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 418,
    r: 6,
    transform: "rotate(0,202,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 430,
    r: 6,
    transform: "rotate(0,202,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 442,
    r: 6,
    transform: "rotate(0,202,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 454,
    r: 6,
    transform: "rotate(0,202,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 466,
    r: 6,
    transform: "rotate(0,202,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 34,
    r: 6,
    transform: "rotate(0,214,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 82,
    r: 6,
    transform: "rotate(0,214,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 118,
    r: 6,
    transform: "rotate(0,214,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 142,
    r: 6,
    transform: "rotate(0,214,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 154,
    r: 6,
    transform: "rotate(0,214,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 166,
    r: 6,
    transform: "rotate(0,214,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 178,
    r: 6,
    transform: "rotate(0,214,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 250,
    r: 6,
    transform: "rotate(0,214,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 262,
    r: 6,
    transform: "rotate(0,214,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 274,
    r: 6,
    transform: "rotate(0,214,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 346,
    r: 6,
    transform: "rotate(0,214,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 358,
    r: 6,
    transform: "rotate(0,214,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 382,
    r: 6,
    transform: "rotate(0,214,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 394,
    r: 6,
    transform: "rotate(0,214,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 418,
    r: 6,
    transform: "rotate(0,214,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 430,
    r: 6,
    transform: "rotate(0,214,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 442,
    r: 6,
    transform: "rotate(0,214,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 34,
    r: 6,
    transform: "rotate(0,226,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 46,
    r: 6,
    transform: "rotate(0,226,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 58,
    r: 6,
    transform: "rotate(0,226,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 70,
    r: 6,
    transform: "rotate(0,226,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 82,
    r: 6,
    transform: "rotate(0,226,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 106,
    r: 6,
    transform: "rotate(0,226,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 130,
    r: 6,
    transform: "rotate(0,226,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 142,
    r: 6,
    transform: "rotate(0,226,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 166,
    r: 6,
    transform: "rotate(0,226,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 178,
    r: 6,
    transform: "rotate(0,226,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 202,
    r: 6,
    transform: "rotate(0,226,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 214,
    r: 6,
    transform: "rotate(0,226,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 226,
    r: 6,
    transform: "rotate(0,226,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 238,
    r: 6,
    transform: "rotate(0,226,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 250,
    r: 6,
    transform: "rotate(0,226,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 262,
    r: 6,
    transform: "rotate(0,226,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 310,
    r: 6,
    transform: "rotate(0,226,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 322,
    r: 6,
    transform: "rotate(0,226,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 334,
    r: 6,
    transform: "rotate(0,226,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 370,
    r: 6,
    transform: "rotate(0,226,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 394,
    r: 6,
    transform: "rotate(0,226,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 442,
    r: 6,
    transform: "rotate(0,226,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 82,
    r: 6,
    transform: "rotate(0,238,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 130,
    r: 6,
    transform: "rotate(0,238,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 142,
    r: 6,
    transform: "rotate(0,238,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 166,
    r: 6,
    transform: "rotate(0,238,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 178,
    r: 6,
    transform: "rotate(0,238,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 202,
    r: 6,
    transform: "rotate(0,238,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 238,
    r: 6,
    transform: "rotate(0,238,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 262,
    r: 6,
    transform: "rotate(0,238,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 298,
    r: 6,
    transform: "rotate(0,238,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 358,
    r: 6,
    transform: "rotate(0,238,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 382,
    r: 6,
    transform: "rotate(0,238,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 406,
    r: 6,
    transform: "rotate(0,238,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 442,
    r: 6,
    transform: "rotate(0,238,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 454,
    r: 6,
    transform: "rotate(0,238,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 34,
    r: 6,
    transform: "rotate(0,250,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 46,
    r: 6,
    transform: "rotate(0,250,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 70,
    r: 6,
    transform: "rotate(0,250,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 106,
    r: 6,
    transform: "rotate(0,250,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 118,
    r: 6,
    transform: "rotate(0,250,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 142,
    r: 6,
    transform: "rotate(0,250,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 166,
    r: 6,
    transform: "rotate(0,250,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 202,
    r: 6,
    transform: "rotate(0,250,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 226,
    r: 6,
    transform: "rotate(0,250,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 6,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 286,
    r: 6,
    transform: "rotate(0,250,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 310,
    r: 6,
    transform: "rotate(0,250,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 334,
    r: 6,
    transform: "rotate(0,250,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 358,
    r: 6,
    transform: "rotate(0,250,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 394,
    r: 6,
    transform: "rotate(0,250,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 406,
    r: 6,
    transform: "rotate(0,250,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 418,
    r: 6,
    transform: "rotate(0,250,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 466,
    r: 6,
    transform: "rotate(0,250,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 34,
    r: 6,
    transform: "rotate(0,262,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 46,
    r: 6,
    transform: "rotate(0,262,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 82,
    r: 6,
    transform: "rotate(0,262,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 118,
    r: 6,
    transform: "rotate(0,262,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 154,
    r: 6,
    transform: "rotate(0,262,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 178,
    r: 6,
    transform: "rotate(0,262,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 226,
    r: 6,
    transform: "rotate(0,262,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 250,
    r: 6,
    transform: "rotate(0,262,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 322,
    r: 6,
    transform: "rotate(0,262,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 334,
    r: 6,
    transform: "rotate(0,262,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 358,
    r: 6,
    transform: "rotate(0,262,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 370,
    r: 6,
    transform: "rotate(0,262,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 394,
    r: 6,
    transform: "rotate(0,262,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 418,
    r: 6,
    transform: "rotate(0,262,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 430,
    r: 6,
    transform: "rotate(0,262,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 454,
    r: 6,
    transform: "rotate(0,262,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 46,
    r: 6,
    transform: "rotate(0,274,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 58,
    r: 6,
    transform: "rotate(0,274,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 70,
    r: 6,
    transform: "rotate(0,274,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 106,
    r: 6,
    transform: "rotate(0,274,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 142,
    r: 6,
    transform: "rotate(0,274,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 154,
    r: 6,
    transform: "rotate(0,274,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 190,
    r: 6,
    transform: "rotate(0,274,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 214,
    r: 6,
    transform: "rotate(0,274,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 226,
    r: 6,
    transform: "rotate(0,274,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 262,
    r: 6,
    transform: "rotate(0,274,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 274,
    r: 6,
    transform: "rotate(0,274,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 310,
    r: 6,
    transform: "rotate(0,274,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 322,
    r: 6,
    transform: "rotate(0,274,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 346,
    r: 6,
    transform: "rotate(0,274,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 358,
    r: 6,
    transform: "rotate(0,274,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 370,
    r: 6,
    transform: "rotate(0,274,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 382,
    r: 6,
    transform: "rotate(0,274,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 394,
    r: 6,
    transform: "rotate(0,274,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 418,
    r: 6,
    transform: "rotate(0,274,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 430,
    r: 6,
    transform: "rotate(0,274,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 34,
    r: 6,
    transform: "rotate(0,286,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 46,
    r: 6,
    transform: "rotate(0,286,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 58,
    r: 6,
    transform: "rotate(0,286,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 70,
    r: 6,
    transform: "rotate(0,286,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 130,
    r: 6,
    transform: "rotate(0,286,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 142,
    r: 6,
    transform: "rotate(0,286,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 154,
    r: 6,
    transform: "rotate(0,286,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 178,
    r: 6,
    transform: "rotate(0,286,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 202,
    r: 6,
    transform: "rotate(0,286,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 262,
    r: 6,
    transform: "rotate(0,286,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 274,
    r: 6,
    transform: "rotate(0,286,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 298,
    r: 6,
    transform: "rotate(0,286,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 310,
    r: 6,
    transform: "rotate(0,286,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 334,
    r: 6,
    transform: "rotate(0,286,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 346,
    r: 6,
    transform: "rotate(0,286,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 358,
    r: 6,
    transform: "rotate(0,286,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 370,
    r: 6,
    transform: "rotate(0,286,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 382,
    r: 6,
    transform: "rotate(0,286,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 406,
    r: 6,
    transform: "rotate(0,286,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 418,
    r: 6,
    transform: "rotate(0,286,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 46,
    r: 6,
    transform: "rotate(0,298,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 82,
    r: 6,
    transform: "rotate(0,298,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 106,
    r: 6,
    transform: "rotate(0,298,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 130,
    r: 6,
    transform: "rotate(0,298,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 142,
    r: 6,
    transform: "rotate(0,298,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 166,
    r: 6,
    transform: "rotate(0,298,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 250,
    r: 6,
    transform: "rotate(0,298,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 262,
    r: 6,
    transform: "rotate(0,298,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 274,
    r: 6,
    transform: "rotate(0,298,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 286,
    r: 6,
    transform: "rotate(0,298,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 310,
    r: 6,
    transform: "rotate(0,298,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 334,
    r: 6,
    transform: "rotate(0,298,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 358,
    r: 6,
    transform: "rotate(0,298,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 394,
    r: 6,
    transform: "rotate(0,298,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 418,
    r: 6,
    transform: "rotate(0,298,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 430,
    r: 6,
    transform: "rotate(0,298,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 442,
    r: 6,
    transform: "rotate(0,298,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 466,
    r: 6,
    transform: "rotate(0,298,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 70,
    r: 6,
    transform: "rotate(0,310,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 82,
    r: 6,
    transform: "rotate(0,310,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 118,
    r: 6,
    transform: "rotate(0,310,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 130,
    r: 6,
    transform: "rotate(0,310,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 142,
    r: 6,
    transform: "rotate(0,310,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 154,
    r: 6,
    transform: "rotate(0,310,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 166,
    r: 6,
    transform: "rotate(0,310,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 214,
    r: 6,
    transform: "rotate(0,310,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 238,
    r: 6,
    transform: "rotate(0,310,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 274,
    r: 6,
    transform: "rotate(0,310,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 298,
    r: 6,
    transform: "rotate(0,310,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 346,
    r: 6,
    transform: "rotate(0,310,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 358,
    r: 6,
    transform: "rotate(0,310,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 370,
    r: 6,
    transform: "rotate(0,310,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 406,
    r: 6,
    transform: "rotate(0,310,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 430,
    r: 6,
    transform: "rotate(0,310,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 442,
    r: 6,
    transform: "rotate(0,310,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 466,
    r: 6,
    transform: "rotate(0,310,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 34,
    r: 6,
    transform: "rotate(0,322,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 58,
    r: 6,
    transform: "rotate(0,322,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 70,
    r: 6,
    transform: "rotate(0,322,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 94,
    r: 6,
    transform: "rotate(0,322,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 106,
    r: 6,
    transform: "rotate(0,322,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 130,
    r: 6,
    transform: "rotate(0,322,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 142,
    r: 6,
    transform: "rotate(0,322,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 202,
    r: 6,
    transform: "rotate(0,322,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 214,
    r: 6,
    transform: "rotate(0,322,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 238,
    r: 6,
    transform: "rotate(0,322,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 262,
    r: 6,
    transform: "rotate(0,322,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 322,
    r: 6,
    transform: "rotate(0,322,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 382,
    r: 6,
    transform: "rotate(0,322,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 394,
    r: 6,
    transform: "rotate(0,322,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 406,
    r: 6,
    transform: "rotate(0,322,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 430,
    r: 6,
    transform: "rotate(0,322,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 466,
    r: 6,
    transform: "rotate(0,322,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 34,
    r: 6,
    transform: "rotate(0,334,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 46,
    r: 6,
    transform: "rotate(0,334,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 58,
    r: 6,
    transform: "rotate(0,334,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 70,
    r: 6,
    transform: "rotate(0,334,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 82,
    r: 6,
    transform: "rotate(0,334,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 94,
    r: 6,
    transform: "rotate(0,334,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 154,
    r: 6,
    transform: "rotate(0,334,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 166,
    r: 6,
    transform: "rotate(0,334,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 178,
    r: 6,
    transform: "rotate(0,334,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 190,
    r: 6,
    transform: "rotate(0,334,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 250,
    r: 6,
    transform: "rotate(0,334,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 298,
    r: 6,
    transform: "rotate(0,334,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 310,
    r: 6,
    transform: "rotate(0,334,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 334,
    r: 6,
    transform: "rotate(0,334,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 358,
    r: 6,
    transform: "rotate(0,334,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 370,
    r: 6,
    transform: "rotate(0,334,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 418,
    r: 6,
    transform: "rotate(0,334,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 430,
    r: 6,
    transform: "rotate(0,334,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 34,
    r: 6,
    transform: "rotate(0,346,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 46,
    r: 6,
    transform: "rotate(0,346,46)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 82,
    r: 6,
    transform: "rotate(0,346,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 94,
    r: 6,
    transform: "rotate(0,346,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 106,
    r: 6,
    transform: "rotate(0,346,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 142,
    r: 6,
    transform: "rotate(0,346,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 154,
    r: 6,
    transform: "rotate(0,346,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 166,
    r: 6,
    transform: "rotate(0,346,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 238,
    r: 6,
    transform: "rotate(0,346,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 250,
    r: 6,
    transform: "rotate(0,346,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 274,
    r: 6,
    transform: "rotate(0,346,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 286,
    r: 6,
    transform: "rotate(0,346,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 346,
    r: 6,
    transform: "rotate(0,346,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 358,
    r: 6,
    transform: "rotate(0,346,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 394,
    r: 6,
    transform: "rotate(0,346,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 430,
    r: 6,
    transform: "rotate(0,346,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 442,
    r: 6,
    transform: "rotate(0,346,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 454,
    r: 6,
    transform: "rotate(0,346,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 466,
    r: 6,
    transform: "rotate(0,346,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 34,
    r: 6,
    transform: "rotate(0,358,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 58,
    r: 6,
    transform: "rotate(0,358,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 82,
    r: 6,
    transform: "rotate(0,358,82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 94,
    r: 6,
    transform: "rotate(0,358,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 118,
    r: 6,
    transform: "rotate(0,358,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 154,
    r: 6,
    transform: "rotate(0,358,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 166,
    r: 6,
    transform: "rotate(0,358,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 190,
    r: 6,
    transform: "rotate(0,358,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 226,
    r: 6,
    transform: "rotate(0,358,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 238,
    r: 6,
    transform: "rotate(0,358,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 250,
    r: 6,
    transform: "rotate(0,358,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 262,
    r: 6,
    transform: "rotate(0,358,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 274,
    r: 6,
    transform: "rotate(0,358,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 298,
    r: 6,
    transform: "rotate(0,358,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 310,
    r: 6,
    transform: "rotate(0,358,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 346,
    r: 6,
    transform: "rotate(0,358,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 382,
    r: 6,
    transform: "rotate(0,358,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 430,
    r: 6,
    transform: "rotate(0,358,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 442,
    r: 6,
    transform: "rotate(0,358,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 34,
    r: 6,
    transform: "rotate(0,370,34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 70,
    r: 6,
    transform: "rotate(0,370,70)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 94,
    r: 6,
    transform: "rotate(0,370,94)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 106,
    r: 6,
    transform: "rotate(0,370,106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 118,
    r: 6,
    transform: "rotate(0,370,118)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 142,
    r: 6,
    transform: "rotate(0,370,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 178,
    r: 6,
    transform: "rotate(0,370,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 190,
    r: 6,
    transform: "rotate(0,370,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 202,
    r: 6,
    transform: "rotate(0,370,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 214,
    r: 6,
    transform: "rotate(0,370,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 250,
    r: 6,
    transform: "rotate(0,370,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 262,
    r: 6,
    transform: "rotate(0,370,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 298,
    r: 6,
    transform: "rotate(0,370,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 334,
    r: 6,
    transform: "rotate(0,370,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 370,
    r: 6,
    transform: "rotate(0,370,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 382,
    r: 6,
    transform: "rotate(0,370,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 394,
    r: 6,
    transform: "rotate(0,370,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 406,
    r: 6,
    transform: "rotate(0,370,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 418,
    r: 6,
    transform: "rotate(0,370,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 430,
    r: 6,
    transform: "rotate(0,370,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 442,
    r: 6,
    transform: "rotate(0,370,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 454,
    r: 6,
    transform: "rotate(0,370,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 466,
    r: 6,
    transform: "rotate(0,370,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 130,
    r: 6,
    transform: "rotate(0,382,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 142,
    r: 6,
    transform: "rotate(0,382,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 154,
    r: 6,
    transform: "rotate(0,382,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 202,
    r: 6,
    transform: "rotate(0,382,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 250,
    r: 6,
    transform: "rotate(0,382,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 262,
    r: 6,
    transform: "rotate(0,382,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 274,
    r: 6,
    transform: "rotate(0,382,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 286,
    r: 6,
    transform: "rotate(0,382,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 370,
    r: 6,
    transform: "rotate(0,382,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 418,
    r: 6,
    transform: "rotate(0,382,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 430,
    r: 6,
    transform: "rotate(0,382,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 442,
    r: 6,
    transform: "rotate(0,382,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 454,
    r: 6,
    transform: "rotate(0,382,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 142,
    r: 6,
    transform: "rotate(0,394,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 154,
    r: 6,
    transform: "rotate(0,394,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 190,
    r: 6,
    transform: "rotate(0,394,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 202,
    r: 6,
    transform: "rotate(0,394,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 214,
    r: 6,
    transform: "rotate(0,394,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 226,
    r: 6,
    transform: "rotate(0,394,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 238,
    r: 6,
    transform: "rotate(0,394,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 274,
    r: 6,
    transform: "rotate(0,394,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 310,
    r: 6,
    transform: "rotate(0,394,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 322,
    r: 6,
    transform: "rotate(0,394,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 346,
    r: 6,
    transform: "rotate(0,394,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 370,
    r: 6,
    transform: "rotate(0,394,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 394,
    r: 6,
    transform: "rotate(0,394,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 418,
    r: 6,
    transform: "rotate(0,394,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 430,
    r: 6,
    transform: "rotate(0,394,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 442,
    r: 6,
    transform: "rotate(0,394,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 466,
    r: 6,
    transform: "rotate(0,394,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 130,
    r: 6,
    transform: "rotate(0,406,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 142,
    r: 6,
    transform: "rotate(0,406,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 178,
    r: 6,
    transform: "rotate(0,406,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 190,
    r: 6,
    transform: "rotate(0,406,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 226,
    r: 6,
    transform: "rotate(0,406,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 274,
    r: 6,
    transform: "rotate(0,406,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 298,
    r: 6,
    transform: "rotate(0,406,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 334,
    r: 6,
    transform: "rotate(0,406,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 370,
    r: 6,
    transform: "rotate(0,406,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 418,
    r: 6,
    transform: "rotate(0,406,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 430,
    r: 6,
    transform: "rotate(0,406,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 454,
    r: 6,
    transform: "rotate(0,406,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 466,
    r: 6,
    transform: "rotate(0,406,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 130,
    r: 6,
    transform: "rotate(0,418,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 142,
    r: 6,
    transform: "rotate(0,418,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 154,
    r: 6,
    transform: "rotate(0,418,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 178,
    r: 6,
    transform: "rotate(0,418,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 202,
    r: 6,
    transform: "rotate(0,418,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 214,
    r: 6,
    transform: "rotate(0,418,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 286,
    r: 6,
    transform: "rotate(0,418,286)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 298,
    r: 6,
    transform: "rotate(0,418,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 310,
    r: 6,
    transform: "rotate(0,418,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 322,
    r: 6,
    transform: "rotate(0,418,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 346,
    r: 6,
    transform: "rotate(0,418,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 358,
    r: 6,
    transform: "rotate(0,418,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 370,
    r: 6,
    transform: "rotate(0,418,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 382,
    r: 6,
    transform: "rotate(0,418,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 394,
    r: 6,
    transform: "rotate(0,418,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 406,
    r: 6,
    transform: "rotate(0,418,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 418,
    r: 6,
    transform: "rotate(0,418,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 454,
    r: 6,
    transform: "rotate(0,418,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 466,
    r: 6,
    transform: "rotate(0,418,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 130,
    r: 6,
    transform: "rotate(0,430,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 142,
    r: 6,
    transform: "rotate(0,430,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 178,
    r: 6,
    transform: "rotate(0,430,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 190,
    r: 6,
    transform: "rotate(0,430,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 202,
    r: 6,
    transform: "rotate(0,430,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 214,
    r: 6,
    transform: "rotate(0,430,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 226,
    r: 6,
    transform: "rotate(0,430,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 238,
    r: 6,
    transform: "rotate(0,430,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 298,
    r: 6,
    transform: "rotate(0,430,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 310,
    r: 6,
    transform: "rotate(0,430,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 346,
    r: 6,
    transform: "rotate(0,430,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 358,
    r: 6,
    transform: "rotate(0,430,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 394,
    r: 6,
    transform: "rotate(0,430,394)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 430,
    r: 6,
    transform: "rotate(0,430,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 454,
    r: 6,
    transform: "rotate(0,430,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 166,
    r: 6,
    transform: "rotate(0,442,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 178,
    r: 6,
    transform: "rotate(0,442,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 202,
    r: 6,
    transform: "rotate(0,442,202)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 226,
    r: 6,
    transform: "rotate(0,442,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 250,
    r: 6,
    transform: "rotate(0,442,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 262,
    r: 6,
    transform: "rotate(0,442,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 274,
    r: 6,
    transform: "rotate(0,442,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 310,
    r: 6,
    transform: "rotate(0,442,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 322,
    r: 6,
    transform: "rotate(0,442,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 334,
    r: 6,
    transform: "rotate(0,442,334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 346,
    r: 6,
    transform: "rotate(0,442,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 358,
    r: 6,
    transform: "rotate(0,442,358)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 406,
    r: 6,
    transform: "rotate(0,442,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 418,
    r: 6,
    transform: "rotate(0,442,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 442,
    r: 6,
    transform: "rotate(0,442,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 454,
    r: 6,
    transform: "rotate(0,442,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 466,
    r: 6,
    transform: "rotate(0,442,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 130,
    r: 6,
    transform: "rotate(0,454,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 142,
    r: 6,
    transform: "rotate(0,454,142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 154,
    r: 6,
    transform: "rotate(0,454,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 166,
    r: 6,
    transform: "rotate(0,454,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 178,
    r: 6,
    transform: "rotate(0,454,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 214,
    r: 6,
    transform: "rotate(0,454,214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 226,
    r: 6,
    transform: "rotate(0,454,226)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 262,
    r: 6,
    transform: "rotate(0,454,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 274,
    r: 6,
    transform: "rotate(0,454,274)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 298,
    r: 6,
    transform: "rotate(0,454,298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 310,
    r: 6,
    transform: "rotate(0,454,310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 322,
    r: 6,
    transform: "rotate(0,454,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 346,
    r: 6,
    transform: "rotate(0,454,346)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 406,
    r: 6,
    transform: "rotate(0,454,406)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 430,
    r: 6,
    transform: "rotate(0,454,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 442,
    r: 6,
    transform: "rotate(0,454,442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 454,
    r: 6,
    transform: "rotate(0,454,454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 466,
    r: 6,
    transform: "rotate(0,454,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 154,
    r: 6,
    transform: "rotate(0,466,154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 166,
    r: 6,
    transform: "rotate(0,466,166)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 178,
    r: 6,
    transform: "rotate(0,466,178)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 238,
    r: 6,
    transform: "rotate(0,466,238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 250,
    r: 6,
    transform: "rotate(0,466,250)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 322,
    r: 6,
    transform: "rotate(0,466,322)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 370,
    r: 6,
    transform: "rotate(0,466,370)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 382,
    r: 6,
    transform: "rotate(0,466,382)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 418,
    r: 6,
    transform: "rotate(0,466,418)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 430,
    r: 6,
    transform: "rotate(0,466,430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 466,
    r: 6,
    transform: "rotate(0,466,466)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 28 28v 84h 84v -84zM 40 40h 60v 60h -60z",
    transform: "rotate(0,70,70)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 36,
    height: 36,
    transform: "rotate(0,70,70)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 388 28v 84h 84v -84zM 400 40h 60v 60h -60z",
    transform: "rotate(90,430,70)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 52,
    width: 36,
    height: 36,
    transform: "rotate(90,430,70)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 28 388v 84h 84v -84zM 40 400h 60v 60h -60z",
    transform: "rotate(-90,70,430)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 412,
    width: 36,
    height: 36,
    transform: "rotate(-90,70,430)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-background-color')",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#18417E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    height: 84,
    width: 84,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#18417E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    height: 36,
    width: 36,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#18417E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 28,
    height: 84,
    width: 84,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#18417E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 52,
    height: 36,
    width: 36,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#18417E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 388,
    height: 84,
    width: 84,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#18417E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 412,
    height: 36,
    width: 36,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#18417E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeExpressQrCode);
export default __webpack_public_path__ + "static/media/adobe-express-qr-code.cece2807b8cae7f82bfe9d73f3f59684.svg";
export { ForwardRef as ReactComponent };